import React, { useEffect, useState } from "react";

export function PwaUpdatePrompt() {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);

  useEffect(() => {
    const handleUpdate = (event: Event) => {
      const worker = (event as CustomEvent<ServiceWorker>).detail;
      if (worker) setWaitingWorker(worker);
    };
    window.addEventListener("remedikeep:pwa-update", handleUpdate);
    return () => window.removeEventListener("remedikeep:pwa-update", handleUpdate);
  }, []);

  if (!waitingWorker) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-[70] mx-auto flex max-w-md items-center gap-3 rounded-lg border border-slate-200 bg-white p-3 shadow-xl" role="status">
      <p className="min-w-0 flex-1 text-sm text-slate-700">
        A new RemediKeep version is ready.
      </p>
      <button
        type="button"
        className="min-h-11 rounded-md bg-slate-900 px-4 text-sm font-medium text-white"
        onClick={() => waitingWorker.postMessage({ type: "SKIP_WAITING" })}
      >
        Update
      </button>
      <button
        type="button"
        aria-label="Dismiss update"
        className="min-h-11 px-2 text-sm text-slate-500"
        onClick={() => setWaitingWorker(null)}
      >
        Later
      </button>
    </div>
  );
}
